export type ViewState = 'home' | 'quiz' | 'results' | 'revision';

export type AnswerMap = Record<string, number | number[]>;
export type SkippedMap = Record<string, boolean>;

export const SPONSOR_UPI_ID = '';
export const SPONSOR_BMC_URL = 'https://buymeacoffee.com/codewithamit';
